//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.TurnAvoidancePathPointsBuilder.js";
let d=[[[0,"DeparturePathMode",1,0],[1,"DeparturePathPointsListBuilder",0,"CAM.TurnAvoidancePathPointsBuilder",0],[0,"DeparturePathReorientToolHolderMode",1,0]],[],[]];
SPLM.CAM.TurnAvoidanceDepartureBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.TurnAvoidanceDepartureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.TurnAvoidanceDepartureBuilder.DeparturePathModes = Object.freeze({
    "None" : "None", "Points" : "Points", "SameAsApproach" : "SameAsApproach", "PointsBeforeToolChange" : "PointsBeforeToolChange", "SameAsApproachBeforeToolChange" : "SameAsApproachBeforeToolChange"});

SPLM.CAM.TurnAvoidanceDepartureBuilder.DeparturePathReorientToolHolderModes = Object.freeze({
    "None" : "None", "Variable" : "Variable"});

export default SPLM;